import { render } from "./ShareComponent.vue?vue&type=template&id=1c125350&scoped=true"
import script from "./ShareComponent.vue?vue&type=script&lang=js"
export * from "./ShareComponent.vue?vue&type=script&lang=js"

import "./ShareComponent.vue?vue&type=style&index=0&id=1c125350&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c125350"]])

export default __exports__